<template>
    <div class="row" v-if="client">
        <div class="col">

            <breadcrumb :transparent="true">
                <breadcrumb-item>
                    <router-link to="/xlrs/accounts/clients">
                        {{ $t('common.clients') }}
                    </router-link>
                </breadcrumb-item>
                <breadcrumb-item active>
                    {{ client.name }}
                </breadcrumb-item>
            </breadcrumb>

            <accesses-crud></accesses-crud>
        </div>
    </div>
</template>

<script>
    import AccessesCrud from './accesses/AccessesCrud';

    export default {

        components: {
            AccessesCrud
        },

        data() {
            return {
                client: null
            }
        },

        beforeRouteEnter(to, from, next) {
            axios.get('/trax/api/front/clients/'+to.params.id)
            .then(resp => {
                next(vm => {
                    vm.client = resp.data.data
                    next()
                })
            });
        }
    }
</script>
